import { BasicAPI } from '../../core-apis/src/apis/config/api/basicApi'

const WIGGOT_CHAT_API = process.env.WIGGOT_CHAT_API ?? ''

class ChatWiggotApi extends BasicAPI {
  constructor() {
    super({ domain: WIGGOT_CHAT_API })
  }
}

export const chatWiggotApi = new ChatWiggotApi()
